import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import { getBlogPostBySlug } from '../services/strapi';

export default function BlogPostPage() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getBlogPostBySlug(slug).then(data => {
      setPost(data?.[0]?.attributes || data?.data?.[0]?.attributes);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, [slug]);

  if (loading) return <div className="container">Indlæser...</div>;
  if (!post) return <div className="container">Indlægget blev ikke fundet. <Link to="/">Tilbage til forsiden</Link></div>;

  return (
    <section className="section">
      <div className="container">
        <Link to="/" style={{ display: 'block', marginBottom: '2rem' }}>← Tilbage til forsiden</Link>
        <h1 className="section__title" style={{ textAlign: 'left' }}>{post.title}</h1>
        <p className="section__subtitle" style={{ textAlign: 'left', marginBottom: '2rem' }}>
          Af {post.author}
        </p>
        <div className="blog-content">
          <ReactMarkdown>{post.content}</ReactMarkdown>
        </div>
      </div>
    </section>
  );
}
